module.exports = __webpack_public_path__ + "img/FinancialPlanning.c8ace31c.png";